import { Tooltip } from "primereact/tooltip";
import { useTranslation } from "react-i18next";

export default function KH1000160007() {
  const { i18n } = useTranslation();

  if (i18n.language === "en") {
    return (
      <>
        <p>
          1. Oknha Koy Le San
          <span className="vertical-align-super b text-xs text-yellow-500 pl-1">
            (b)
          </span>
          <Tooltip target=".b" position="right" event="both">
            Executive Chairman
          </Tooltip>
        </p>
        <p>
          2. Dato' Yap Ting Chiat
          <span className="vertical-align-super c text-xs text-yellow-500 pl-1">
            (c)
          </span>
          <Tooltip target=".c" position="right" event="both">
            Chief Executive Director
          </Tooltip>
        </p>
        <p>
          3. Oknha Meng Lee
          <span className="vertical-align-super d text-xs text-yellow-500 pl-1">
            (d)
          </span>
          <Tooltip target=".d" position="right" event="both">
            Non-Executive Director
          </Tooltip>
        </p>
        <p>
          4. Mr. Tang Chun Kiu
          <span className="vertical-align-super e text-xs text-yellow-500 pl-1">
            (e)
          </span>
          <Tooltip target=".e" position="right" event="both">
            Non-Executive Director
          </Tooltip>
        </p>
        <p>
          5. Mr. Yap Maow Jun
          <span className="vertical-align-super f text-xs text-yellow-500 pl-1">
            (f)
          </span>
          <Tooltip target=".f" position="right" event="both">
            Non-Executive Director
          </Tooltip>
        </p>
        <p>
          6. Mr. Yap Teng Wui
          <span className="vertical-align-super f text-xs text-yellow-500 pl-1">
            (g)
          </span>
          <Tooltip target=".g" position="right" event="both">
            Non-Executive Director
          </Tooltip>
        </p>
        <p>
          7. Mr. Tang Chat Tong
          <span className="vertical-align-super f text-xs text-yellow-500 pl-1">
            (h)
          </span>
          <Tooltip target=".h" position="right" event="both">
            Non-Executive Director
          </Tooltip>
        </p>
        <p>
          8. Mr. Tan Ser Chhay
          <span className="vertical-align-super f text-xs text-yellow-500 pl-1">
            (i)
          </span>
          <Tooltip target=".i" position="right" event="both">
            Independent Director
          </Tooltip>
        </p>
        <p>
          9. Dato' Tan Teck Zin
          <span className="vertical-align-super f text-xs text-yellow-500 pl-1">
            (j)
          </span>
          <Tooltip target=".j" position="right" event="both">
            Independent Director
          </Tooltip>
        </p>
      </>
    );
  }
  return (
    <>
      <p>
        ១. លោកឧកញ្ញ៉ា កួយ ឡេសាន
        <span className="vertical-align-super b text-xs text-yellow-500 pl-1">
          (b)
        </span>
        <Tooltip target=".b" position="right" event="both">
          ប្រធានក្រុមប្រឹក្សាភិបាលប្រតិបត្តិ
        </Tooltip>
      </p>
      <p>
        ២. លោក Dato' Yap Ting
        <span className="vertical-align-super c text-xs text-yellow-500 pl-1">
          (c)
        </span>
        <Tooltip target=".c" position="right" event="both">
          អភិបាលប្រតិបត្តិ
        </Tooltip>
      </p>
      <p>
        ៣. លោកឧកញ្ញ៉ា ម៉េង លី
        <span className="vertical-align-super d text-xs text-yellow-500 pl-1">
          (d)
        </span>
        <Tooltip target=".d" position="right" event="both">
          អភិបាលមិនប្រតិបត្តិ
        </Tooltip>
      </p>
      <p>
        ៤. លោក Tang Chun Kiu
        <span className="vertical-align-super e text-xs text-yellow-500 pl-1">
          (e)
        </span>
        <Tooltip target=".e" position="right" event="both">
          អភិបាលមិនប្រតិបត្តិ
        </Tooltip>
      </p>
      <p>
        ៥. លោក Yap Maow Jun
        <span className="vertical-align-super f text-xs text-yellow-500 pl-1">
          (f)
        </span>
        <Tooltip target=".f" position="right" event="both">
          អភិបាលមិនប្រតិបត្តិ
        </Tooltip>
      </p>
      <p>
        ៦. លោក Yab Teng Wui
        <span className="vertical-align-super f text-xs text-yellow-500 pl-1">
          (g)
        </span>
        <Tooltip target=".g" position="right" event="both">
          អភិបាលមិនប្រតិបត្តិ
        </Tooltip>
      </p>
      <p>
        ៧. លោក Tang Chat Tong
        <span className="vertical-align-super f text-xs text-yellow-500 pl-1">
          (h)
        </span>
        <Tooltip target=".h" position="right" event="both">
          អភិបាលមិនប្រតិបត្តិ
        </Tooltip>
      </p>
      <p>
        ៨. លោក តាន់ សែឆាយ
        <span className="vertical-align-super f text-xs text-yellow-500 pl-1">
          (i)
        </span>
        <Tooltip target=".i" position="right" event="both">
          អភិបាលឯករាជ្យ
        </Tooltip>
      </p>
      <p>
        ៩. លោក Dato Tan Teck Zin
        <span className="vertical-align-super f text-xs text-yellow-500 pl-1">
          (j)
        </span>
        <Tooltip target=".j" position="right" event="both">
          អភិបាលឯករាជ្យ
        </Tooltip>
      </p>
    </>
  );
}
